import { LAYOUT_CONFIG, DEFAULT_CONFIG, BREAKPOINT, SERVER_TOKEN } from '@ngbracket/ngx-layout/core';
export * from '@ngbracket/ngx-layout/core';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';
export * from '@ngbracket/ngx-layout/extended';
import { FlexModule } from '@ngbracket/ngx-layout/flex';
export * from '@ngbracket/ngx-layout/flex';
import { GridModule } from '@ngbracket/ngx-layout/grid';
export * from '@ngbracket/ngx-layout/grid';
import { isPlatformServer } from '@angular/common';
import * as i0 from '@angular/core';
import { PLATFORM_ID, NgModule, Inject, Version } from '@angular/core';

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * FlexLayoutModule -- the main import for all utilities in the Angular Layout library
 * * Will automatically provide Flex, Grid, and Extended modules for use in the application
 * * Can be configured using the static withConfig method, options viewable on the Wiki's
 *   Configuration page
 */
let FlexLayoutModule = /*#__PURE__*/(() => {
  class FlexLayoutModule {
    /**
     * Initialize the FlexLayoutModule with a set of config options,
     * which sets the corresponding tokens accordingly
     */
    static withConfig(configOptions,
    // tslint:disable-next-line:max-line-length
    breakpoints = []) {
      return {
        ngModule: FlexLayoutModule,
        providers: configOptions.serverLoaded ? [{
          provide: LAYOUT_CONFIG,
          useValue: {
            ...DEFAULT_CONFIG,
            ...configOptions
          }
        }, {
          provide: BREAKPOINT,
          useValue: breakpoints,
          multi: true
        }, {
          provide: SERVER_TOKEN,
          useValue: true
        }] : [{
          provide: LAYOUT_CONFIG,
          useValue: {
            ...DEFAULT_CONFIG,
            ...configOptions
          }
        }, {
          provide: BREAKPOINT,
          useValue: breakpoints,
          multi: true
        }]
      };
    }
    constructor(serverModuleLoaded, platformId) {
      if (isPlatformServer(platformId) && !serverModuleLoaded) {
        console.warn('Warning: Flex Layout loaded on the server without FlexLayoutServerModule');
      }
    }
    static {
      this.ɵfac = function FlexLayoutModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FlexLayoutModule)(i0.ɵɵinject(SERVER_TOKEN), i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FlexLayoutModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [FlexModule, ExtendedModule, GridModule, FlexModule, ExtendedModule, GridModule]
      });
    }
  }
  return FlexLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** Current version of Angular Flex-Layout. */
const VERSION = new Version('19.0.0');

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of Angular Flex-Layout.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FlexLayoutModule, VERSION };
